import { render, staticRenderFns } from "./business-category-picker.vue?vue&type=template&id=09bd0388&scoped=true&"
import script from "./business-category-picker.vue?vue&type=script&lang=js&"
export * from "./business-category-picker.vue?vue&type=script&lang=js&"
import style0 from "./business-category-picker.vue?vue&type=style&index=0&lang=less&"
import style1 from "./business-category-picker.vue?vue&type=style&index=1&id=09bd0388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd0388",
  null
  
)

export default component.exports